export enum REFERRAL_ACTIONS {
	LOAD = '[Referral] Load Referrals',
	CLEAR_SEARCH_ZIP = '[Referral] Clear Search Zip',
	SEARCH_ACCOUNTS = '[Referral] Search Accounts',
	SEARCH_SUB_ACCOUNTS = '[Referral] Search Sub Account',
	CLEAR_SUB_ACCOUNTS = '[Referral] Clear Sub Accounts',
}

export namespace ReferralAction {
	export class LoadReferrals {
		static readonly type = REFERRAL_ACTIONS.LOAD
	}

	/**
	 * @deprecated - the search referral by zip has been replaced by an org code input
	 */
	export class ClearSearchZip {
		static readonly type = REFERRAL_ACTIONS.CLEAR_SEARCH_ZIP
	}

	export class SearchAccounts {
		static readonly type = REFERRAL_ACTIONS.SEARCH_ACCOUNTS
		constructor(public payload?: string) {}
	}

	export class SearchSubAccount {
		static readonly type = REFERRAL_ACTIONS.SEARCH_SUB_ACCOUNTS
		constructor(public payload: string) {}
	}

	export class ClearSubAccounts {
		static readonly type = REFERRAL_ACTIONS.CLEAR_SUB_ACCOUNTS
	}
}
